import React, { use, useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, Typography, DialogActions, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styled from 'styled-components'
import BrandingColors from '../../styles/color';
import DefaultTable from '../../utils/Table/DefaultTable';
import { ButtonWrapperFilter, useStyles } from '../../styles/common-styles'
import { useTranslation } from 'react-i18next';
import HeaderTitle from '../../utils/HeaderTitle/HeaderTitle';
import { studentAlertKey } from '../../helper/constants';
const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
const StyledTitle = styled(BootstrapDialogTitle)`
    background-color : ${BrandingColors.white};
    color: ${BrandingColors.darkBlack};
    border-bottom: 2px solid ${BrandingColors.fontOrangeCustom};
    display: flex;
    padding: 16px 16px 10px 16px !important;
    button{
        color: ${BrandingColors.darkBlack};
        padding: 0;
        border-radius: 0;
        height:24px;
    }
    span{
        flex:1 1 0;
        line-height: 2;
    }
`
const DialogWrapper = styled.div`
    min-width: 825px;
`
const AlertsModal = (props) => {
    const { onClose, popupData, children } = props;
    const { popupHeaderTitle, alertsData, open, studentId, studentName , okAction, handleClose } = popupData;
    const classess = useStyles();
    const { t } = useTranslation();
    let allowOpen = open;
    


    const [tableCourseInGroupCell1] = useState([
        { id: 'textTerm', numeric: true, disablePadding: false, label: t('students.textTerm', { ns: 'tableHeadCells' }) },
        { id: 'enrollmentStatus', numeric: true, disablePadding: false, label: t('students.enrollmentStatus', { ns: 'tableHeadCells' }) },
        { id: 'alert', numeric: true, disablePadding: false, label: t('students.alert', { ns: 'tableHeadCells' }) },
        { id: 'studentLevel', numeric: true, disablePadding: false, label: t('students.studentLevel', { ns: 'tableHeadCells' }) },
        { id: 'collegeLevel', numeric: true, disablePadding: false, label: t('students.collegeLevel', { ns: 'tableHeadCells' }) },
        { id: 'classification', numeric: true, disablePadding: false, label: t('students.classification', { ns: 'tableHeadCells' }) },
        { id: 'studentLoad', numeric: true, disablePadding: false, label: t('students.studentLoad', { ns: 'tableHeadCells' }) },
        { id: 'commuter', numeric: true, disablePadding: false, label: t('students.commuter', { ns: 'tableHeadCells' }) },
        { id: 'description', numeric: true, disablePadding: false, label: t('students.description', { ns: 'tableHeadCells' }) },
        { id: 'academicStatus', numeric: true, disablePadding: false, label: t('students.academicStatus', { ns: 'tableHeadCells' }) },
        { id: 'financialAid', numeric: true, disablePadding: false, label: t('students.financialAid', { ns: 'tableHeadCells' }) },
        { id: 'refundType', numeric: true, disablePadding: false, label: t('students.refundType', { ns: 'tableHeadCells' }) },
        { id: 'costType', numeric: true, disablePadding: false, label: t('students.costType', { ns: 'tableHeadCells' }) },
        { id: 'campus', numeric: true, disablePadding: false, label: t('students.campus', { ns: 'tableHeadCells' }) },
        { id: 'registerStatus', numeric: true, disablePadding: false, label: t('students.registerStatus', { ns: 'tableHeadCells' }) },
        { id: 'gpaGrouping', numeric: true, disablePadding: false, label: t('students.gpaGrouping', { ns: 'tableHeadCells' }) },
        { id: 'commentPosition', numeric: true, disablePadding: false, label: t('students.commentPosition', { ns: 'tableHeadCells' }) },
        { id: 'transcriptComment', numeric: true, disablePadding: false, label: t('students.transcriptComment', { ns: 'tableHeadCells' }) },
        { id: 'leaveOfAbsenceDue', numeric: true, disablePadding: false, label: t('students.leaveOfAbsenceDue', { ns: 'tableHeadCells' }) },
        { id: 'vocation', numeric: true, disablePadding: false, label: t('students.vocation', { ns: 'tableHeadCells' }) },
        { id: 'maxAllowedHours', numeric: true, disablePadding: false, label: t('students.maxAllowedHours', { ns: 'tableHeadCells' }) },
        { id: 'chargeInsurance', numeric: true, disablePadding: false, label: t('students.chargeInsurance', { ns: 'tableHeadCells' }) },
        { id: 'statEffectiveDate', numeric: true, disablePadding: false, label: t('students.statEffective', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'cohortGroup', numeric: true, disablePadding: false, label: t('students.cohortGroup', { ns: 'tableHeadCells' }) },
        { id: 'loadChangeDate', numeric: true, disablePadding: false, label: t('students.loadChangeDate', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'studentRegistered', numeric: true, disablePadding: false, label: t('students.studentRegistered', { ns: 'tableHeadCells' }) },
        { id: 'insertUserID', numeric: true, disablePadding: false, label: t('students.insertUserID', { ns: 'tableHeadCells' }) },
        { id: 'insertTime', numeric: true, disablePadding: false, label: t('students.insertTime', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'updateUserID', numeric: true, disablePadding: false, label: t('students.updateUserID', { ns: 'tableHeadCells' }) },
        { id: 'updateTime', numeric: true, disablePadding: false, label: t('students.updateTime', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'gradeCatalog', numeric: true, disablePadding: false, label: t('students.gradeCatalog', { ns: 'tableHeadCells' }) },
        { id: 'gradecatalogID', numeric: true, disablePadding: false, label: t('students.gradeCatalogID', { ns: 'tableHeadCells' }) },
        { id: 'nonStateReporting', numeric: true, disablePadding: false, label: t('students.nonStateReporting', { ns: 'tableHeadCells' }) },
        { id: 'degreeSeeking', numeric: true, disablePadding: false, label: t('students.degreeSeeking', { ns: 'tableHeadCells' }) },
        { id: 'institutionalSAP', numeric: true, disablePadding: false, label: t('students.institutionalSAP', { ns: 'tableHeadCells' }) },
        { id: 'institutionalSAPID', numeric: true, disablePadding: false, label: t('students.institutionalSAPID', { ns: 'tableHeadCells' }) },
        { id: 'governmentalSAP', numeric: true, disablePadding: false, label: t('students.governmentalSAP', { ns: 'tableHeadCells' }) },
        { id: 'governmentalSAPID', numeric: true, disablePadding: false, label: t('students.governmentalSAPID', { ns: 'tableHeadCells' }) },
        { id: 'lastDateOfAttendance', numeric: true, disablePadding: false, label: t('students.lastDateOfAttendance', { ns: 'tableHeadCells' }) },
        { id: 'studentWorker', numeric: true, disablePadding: false, label: t('students.studentWork', { ns: 'tableHeadCells' }) },
    ])
    const [tableCourseInGroupCell2] = useState([
        { id: 'holdStatus', numeric: true, disablePadding: false, label: t('students.holdStatus', { ns: 'tableHeadCells' }) },
        { id: 'holdDate', numeric: true, disablePadding: false, label: t('students.holdDate', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'holdCategory', numeric: true, disablePadding: false, label: t('students.holdCategory', { ns: 'tableHeadCells' }) },
        { id: 'holdDescription', numeric: true, disablePadding: false, label: t('students.holdDescription', { ns: 'tableHeadCells' }) },
        { id: 'voidReason', numeric: true, disablePadding: false, label: t('students.voidReason', { ns: 'tableHeadCells' }) },
        { id: 'voidUserID', numeric: true, disablePadding: false, label: t('students.voidUserID', { ns: 'tableHeadCells' }) },
        { id: 'stopStatement', numeric: true, disablePadding: false, label: t('students.stopStatement', { ns: 'tableHeadCells' }) },
        { id: 'stopTranscript', numeric: true, disablePadding: false, label: t('students.stopTranscript', { ns: 'tableHeadCells' }) },
        { id: 'stopGradeCard', numeric: true, disablePadding: false, label: t('students.stopGradeCard', { ns: 'tableHeadCells' }) },
        { id: 'insertUserID', numeric: true, disablePadding: false, label: t('students.insertUserID', { ns: 'tableHeadCells' }) },
        { id: 'insertTime', numeric: true, disablePadding: false, label: t('students.insertTime', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'updateUserID', numeric: true, disablePadding: false, label: t('students.updateUserID', { ns: 'tableHeadCells' }) },
        { id: 'updateTime', numeric: true, disablePadding: false, label: t('students.updateTime', { ns: 'tableHeadCells' }), dateTime: true },
        { id: 'stopOnLineRegistration', numeric: true, disablePadding: false, label: t('students.stopOnLineRegistration', { ns: 'tableHeadCells' }) },
        { id: 'location', numeric: true, disablePadding: false, label: t('students.location', { ns: 'tableHeadCells' }) },
        { id: 'locationID', numeric: true, disablePadding: false, label: t('students.locationID', { ns: 'tableHeadCells' }) },
        { id: 'restrictAccessToLocation', numeric: true, disablePadding: false, label: t('students.restrictAccessToLocation', { ns: 'tableHeadCells' }) },
    ])
    const [tableCourseInGroupCell3] = useState([
        { id: 'ferpA_Item', numeric: true, disablePadding: false, label: t('students.ferpA_Item', { ns: 'tableHeadCells' }) },
        { id: 'allowDisplay', numeric: true, disablePadding: false, label: t('students.allowDisplay', { ns: 'tableHeadCells' }) },
        { id: 'relationCanRecv', numeric: true, disablePadding: false, label: t('students.relationCanRecv', { ns: 'tableHeadCells' }) },
    ])

    const tableData =  [
            { tableName: `${t('commonLabel.academicAlerts')}`, data: "academicAlerts", headcells: tableCourseInGroupCell1 },
            { tableName: t('commonLabel.businessAlerts'), data: "businessAlerts", headcells: tableCourseInGroupCell2 },
            { tableName: t('commonLabel.ferpaWarning'), data: "ferpaWarnings", headcells: tableCourseInGroupCell3 }
        ]

    useEffect   (() => {
        if (open) { 
            let studentalert = sessionStorage.getItem("studentId-alert");
            if (studentalert == studentId) {
                allowOpen = false                
            }
        }

    }, [open]);

    const saveAlert = () => {
        if (okAction) {
            sessionStorage.setItem(studentAlertKey, studentId);
            okAction();
        } else {
            handleClose();
        }
    }

    return (
        <div >
            { allowOpen  && <Dialog
                onClose={onClose}
                maxWidth={'lg'}
                aria-labelledby="customized-dialog-title"
                open={allowOpen}
                className={classess.root}
            >
                <StyledTitle id="customized-dialog-title" onClose={onClose}>
                	<HeaderTitle headerTitle={popupHeaderTitle } />
                </StyledTitle>
                
                <DialogContent dividers>
                    <DialogContentText id="alert-dialog-slide-description">
                        {studentName && <span className="studentName"> {studentName} ID: {studentId}</span>}
                    </DialogContentText>
                    <DialogWrapper>{

                        tableData.map((value, key) => {
                            return (
                                <>
                                    <Typography className="headerTitle">{value.tableName}</Typography>
                                    <DefaultTable trackingLabel={"AlertModal"} isLookup={true} headCells={value.headcells} rows={alertsData[value.data]} pagination={true} />
                                    <br />
                                </>
                            )
                        })

                    }
                        {children}
                    </DialogWrapper>
                </DialogContent>
                <DialogActions>
                    <ButtonWrapperFilter className='centerButton'>
                        <Button className='BgYellowOrange search' variant="contained" size="large" onClick={saveAlert} >
                            {t('buttonLabel.ok')}
                        </Button>
                        <Button className="BgLightBlue search" variant="contained" size="large" type="reset" onClick={handleClose}>
                            {t('buttonLabel.cancel')}
                        </Button>
                    </ButtonWrapperFilter>
                </DialogActions>
            </Dialog> }
        </div>
    );
}
export default React.memo(AlertsModal);
